import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ChartBox } from "./ReportViz";

interface MonthlyData {
  year: number;
  month: number;
  totalPosts: number;
  totalImpressions: number;
  totalReach: number;
  totalEngagement: number;
}

interface TrendsChartProps {
  historicalData: MonthlyData[];
}

const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const LINES = [
  { key: "Posts", color: "#8B5CF6" },
  { key: "Impressions", color: "#3B82F6" },
  { key: "Reach", color: "#10B981" },
  { key: "Engagement", color: "#F59E0B" },
] as const;

export const TrendsChart: React.FC<TrendsChartProps> = ({ historicalData }) => {
  const chartData = historicalData.map((d) => ({
    month: MONTH_NAMES[d.month - 1],
    Posts: d.totalPosts,
    Impressions: Math.round(d.totalImpressions / 1000),
    Reach: Math.round(d.totalReach / 1000),
    Engagement: d.totalEngagement,
  }));

  return (
    <div>
      <ChartBox height={220}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <XAxis dataKey="month" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} width={40} />
            <Tooltip />
            {LINES.map((l) => (
              <Line
                key={l.key}
                type="monotone"
                dataKey={l.key}
                stroke={l.color}
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </ChartBox>
      <div className="flex items-center justify-center gap-4 mt-1">
        {LINES.map((l) => (
          <div key={l.key} className="flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: l.color }} />
            <span className="text-xs text-gray-500">{l.key}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
